export function normalizeKeyword(k) {
  return k.trim().toLowerCase();
}

export function computeKeywordIdf(summaries) {
  const df = new Map();
  summaries.forEach((s) => {
    new Set(s.keywords.map(normalizeKeyword)).forEach((k) => df.set(k, (df.get(k) || 0) + 1));
  });
  const idf = new Map();
  const n = summaries.length;
  df.forEach((count, k) => idf.set(k, Math.log(1 + n / count)));
  return idf;
}

export function weightedKeywordJaccard(a, b, idf) {
  const setA = new Set(a.map(normalizeKeyword));
  const setB = new Set(b.map(normalizeKeyword));
  let interWeight = 0;
  let unionWeight = 0;
  new Set([...setA, ...setB]).forEach((k) => {
    const w = idf.get(k) || 0;
    unionWeight += w;
    if (setA.has(k) && setB.has(k)) interWeight += w;
  });
  return unionWeight === 0 ? 0 : interWeight / unionWeight;
}
